import React, { useState } from 'react';
import {
  Header,
  Page,
  Content,
} from '@backstage/core-components';
import {
  Card,
  CardContent,
  Box,
  Tabs,
  Tab,
} from '@material-ui/core';
import { TabPanel } from '../../components/tabpanel/TabPanel';
import { RequestsTab } from './RequestsTab';
import { WorkspacesTab } from './WorkspacesTab';
import { Environment } from './types';

export const WorkspacesPage = ({ environment }: { environment: Environment }) => {
  const [mainTabValue, setMainTabValue] = useState('workspaces');

  const handleMainTabChange = (_event: React.ChangeEvent<{}>, newValue: string) => {
    setMainTabValue(newValue);
  };

  return (
    <Page themeId="tool">
      <Header title={`Workspaces (${environment})`} subtitle="Manage workspaces and requests." />

      <Content>
        <Card>
          <CardContent>
            <Box display="flex" flexDirection="column" gridRowGap={24}>
              <Tabs
                value={mainTabValue}
                onChange={handleMainTabChange}
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label="Workspaces" value="workspaces" />
                <Tab label="Requests" value="requests" />
              </Tabs>

              <TabPanel value={mainTabValue} index="workspaces">
                <WorkspacesTab environment={environment} />
              </TabPanel>

              <TabPanel value={mainTabValue} index="requests">
                <RequestsTab environment={environment} />
              </TabPanel>
            </Box>
          </CardContent>
        </Card>
      </Content>
    </Page>
  );
};
